export default class SettingsValidationObject {
    constructor () {
        this.maximumAge = {
            rangeRule: {
                isValid: true
            }
        };

        this.minimumLength = {
            sumOfFieldsRule: {
                isValid: true
            },
            rangeRule: {
                isValid: true
            }
        };
        this.alphabeticalCharacters = {
            sumOfFieldsRule: {
                isValid: true
            },
            minimumPasswordLengthRule: {
                isValid: true
            }
        };
        this.uppercaseCharacters = {
            minimumAlphabeticalCharactersLengthRule: {
                isValid: true
            }
        };
        this.lowercaseCharacters = {
            minimumAlphabeticalCharactersLengthRule: {
                isValid: true
            }
        };
        this.numericCharacters = {
            minimumPasswordLengthRule: {
                isValid: true
            }
        };
        this.punctuationOrOtherCharacters = {
            minimumPasswordLengthRule: {
                isValid: true
            }
        };

        this.isValid = true;
    }

    createCopy () {
        const object = new SettingsValidationObject();
        object.minimumLength = this.minimumLength;
        object.alphabeticalCharacters = this.alphabeticalCharacters;
        object.uppercaseCharacters = this.uppercaseCharacters;
        object.lowercaseCharacters = this.lowercaseCharacters;
        object.numericCharacters = this.numericCharacters;
        object.punctuationOrOtherCharacters = this.punctuationOrOtherCharacters;
        return object;
    }
}
